module.exports = __webpack_public_path__ + "img/UndergroundSea.d579696d.png";